export var MosAppsHostedAtRoot = [
    'chat',
    'onedrive',
    'testapp',
    'prepare',
    'create',
];
//# sourceMappingURL=RoutePaths.js.map